import { createColumnHelper } from "@tanstack/react-table";
import { ShipmentStatusBadge } from "../OrderDetailPage";
const columnHelper = createColumnHelper();

export const shipmentDetailTableColumnsConfig = {
  shipmentDetail: (handleOpenModal, handleOrderDetails, hasVrp) => [
    columnHelper.accessor(hasVrp ? "lot_id" : "item", {
      header: hasVrp ? "Lot Id" : "Item Name",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      cell: (info) => <ShipmentStatusBadge status={info.getValue()} showTitle={false}/>,
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("qty", {
      header: "Qty",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("price", {
      header: "Total Amt",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
  ],
};
